const NON_WORD_UNICODE = /[^\p{L}\p{N}\s-]/gu;

export function normalizeWhitespace(value: string) {
  return value.replace(/\s+/g, " ").trim();
}

export function toSlug(value: string | null | undefined, locale: "en" | "fa") {
  if (!value) return "";
  const normalized = normalizeWhitespace(value).toLowerCase();
  const cleaned =
    locale === "fa"
      ? normalized.replace(NON_WORD_UNICODE, "")
      : normalized.replace(/[^a-z0-9\s-]/g, "");
  return cleaned.replace(/\s+/g, "-").replace(/-+/g, "-").replace(/^-|-$/g, "");
}

export function ensureSlug(
  primary: string | null | undefined,
  fallback: string | null | undefined,
  locale: "en" | "fa"
) {
  const primarySlug = toSlug(primary, locale);
  if (primarySlug) return primarySlug;
  return toSlug(fallback, locale);
}
